import {
  IFileData,
  ISQLSeedingTranslator,
} from '@principle-theorem/practice-migrations/interfaces';
import { IProvider } from '@principle-theorem/shared';

export class CorePracticePatientCommunicationTranslator
  implements ISQLSeedingTranslator, IProvider<IFileData, string[]>
{
  matchingFilenames = ['communication.csv'];
  commands = [`sed -i 's/From/Sender/'`, `sed -i 's/To/Receiver/'`];

  canProvide(data: IFileData): boolean {
    return this.matchingFilenames.includes(data.fileName);
  }

  execute(data: IFileData): string[] {
    return this.commands.map((cmd) => `${cmd} ${data.filePath}`);
  }
}
